import firebase from 'firebase/compat/app';

const firebaseConfig = {
  apiKey:process.env.REACT_APP_APIKEY,
  authDomain:process.env.REACT_APP_AUTHDOMAIN,
  projectId:process.env.REACT_APP_PROJECTID,
};

export const app = firebase.initializeApp(firebaseConfig);
